export default __webpack_public_path__ + "f7691f3804c7099cad7f5087ff5f42db.png";